import './scss/FilterAndSort.scss';
import React, {FunctionComponent, useEffect, useState} from "react";

// Filter & Sort component in mobile view
let FilterAndSort: FunctionComponent<any> = ({controller}) => {
  const [stateFilterAndSort, setStateFilterAndSort] = useState(controller.state);
  const overlay = document.getElementsByClassName("fog-of-war-overlay")[0];
  const sortDropdown = document.getElementsByClassName("sort-dropdown-items")[0];
  let totalFilter = stateFilterAndSort.dateFacetBreadcrumbs.length;
  stateFilterAndSort.facetBreadcrumbs.map((item: any) => {if (item.facetId !== "common_categoryfilter") {totalFilter += item.values.length}});
  stateFilterAndSort.numericFacetBreadcrumbs.map((item: any) => {totalFilter += item.values.length});

  useEffect(() => {
    controller.subscribe(() => {
      setStateFilterAndSort(controller.state);
    });
  }, [controller]);

  function openFilter(){
    let facetContainer = document.getElementsByClassName("sc_leftNavListDiv")[0];
    facetContainer?.classList.add("mobile-active_show");
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
    sortDropdown?.classList.remove("active");
    overlay?.classList.remove("dropdown-open");
  }

  function removeActiveOnResize(){
    if(window.innerWidth > 767){
      let facetContainer = document.getElementsByClassName("sc_leftNavListDiv")[0];
      facetContainer?.classList.remove("mobile-active_show");
      document.getElementsByTagName("body")[0].style.overflow = "auto";
      overlay?.classList.remove("dropdown-open");
    } else {
      if (sortDropdown?.classList.contains("active")) {
        overlay?.classList.add("dropdown-open");
      } else {
        overlay?.classList.remove("dropdown-open");
      }
    }
  }

  function openSortDropdown(){
    sortDropdown?.classList.add("active");
    overlay?.classList.add("dropdown-open");
    if (sortDropdown?.querySelectorAll('.dropdown-item.current-sort')?.length < 1) {
      sortDropdown.querySelector('.dropdown-item')?.classList.add('current-sort');
    }
  }

  window.onresize = removeActiveOnResize;

  useEffect(() => {
    document.addEventListener('click', (e:any) => {
      if (!e.target.classList.contains('sort-btn')) {
        overlay?.classList.remove("dropdown-open");
        sortDropdown?.classList.remove('active');
      }
    });
  }, []);

  return (
    <div className={totalFilter > 0 ? "filter-sort-container filter-sort-container_active" : "filter-sort-container"}>
      <button className={totalFilter > 0 ? "filters-btn active" : "filters-btn"} onClick={() => openFilter()}>Filter & Sort {totalFilter > 0 ? `(${totalFilter})` : ""}</button>
    </div>
  );
}

export default FilterAndSort;
